"use client";

import * as Sentry from "@sentry/nextjs";
import { type NextPage } from "next";
import { useEffect } from "react";

import CustomError from "./error";
import type { ErrorProps } from "./error";

declare global {
  interface Window {
    __opsReportError?: (message: string, stack?: string) => void;
  }
}

export const GlobalError: NextPage<ErrorProps> = (props) => {
  useEffect(() => {
    Sentry.captureException(props.error);
    // React swallows a render error before window.onerror can see it, so the
    // beacon only learns about this class of failure if we hand it over.
    // Optional-chained because beacon.js is production-only, and wrapped
    // because reporting an error must never be what takes down the error page.
    try {
      window.__opsReportError?.(props.error?.message ?? "Unhandled render error", props.error?.stack);
    } catch {}
  }, [props.error]);
  return (
    <html>
      <body>
        <CustomError {...props} />
      </body>
    </html>
  );
};

export default GlobalError;
